export default __webpack_public_path__ + "mini-play-button.svg";